export type TrackingWorksheetRowStatus =
  | 'passed'
  | 'next'
  | 'pending'
  | 'not-verified'
  | 'skipped';

export type TrackingWorksheetPassSource =
  | { kind: 'agm'; uid: number }
  | { kind: 'manual'; uid: null };

export type TrackingWorksheetDistanceSource = 'measured' | 'gps';

export const TrackingWorksheetColumnIds = {
  marker: 'marker',
  linkedAgms: 'linkedAgms',
  passSource: 'passSource',
  passUtc: 'passUtc',
  passLocal: 'passLocal',
  etaUtc: 'etaUtc',
  etaLocal: 'etaLocal',
  countdown: 'countdown',
  legSpeed: 'legSpeed',
  status: 'status',
  trackState: 'trackState',
  legDistance: 'legDistance',
  distanceFromLaunch: 'distanceFromLaunch',
  runAverageSpeed: 'runAverageSpeed',
  latitude: 'latitude',
  longitude: 'longitude',
} as const;

export type TrackingWorksheetColumnId =
  (typeof TrackingWorksheetColumnIds)[keyof typeof TrackingWorksheetColumnIds];

export type TrackingWorksheetTrackStateLabel = 'TRACK' | 'SKIP' | 'UNKNOWN';

export function formatTrackingWorksheetTrackState(
  trackState: string | null | undefined
): TrackingWorksheetTrackStateLabel {
  switch (trackState) {
    case 'T':
      return 'TRACK';
    case 'S':
      return 'SKIP';
    default:
      return 'UNKNOWN';
  }
}

export interface TrackingWorksheetRow {
  pipelineSectionMarkerId: number;
  sortOrder: number;
  markerName: string;
  description: string;
  trackState: string;
  status: TrackingWorksheetRowStatus;
  linkedUids: number[];
  passSource: TrackingWorksheetPassSource | null;
  passageTimeUtc: Date | null;
  etaUtc: Date | null;
  countdownSeconds: number | null;
  legDistanceMeters: number | null;
  legDistanceSource: TrackingWorksheetDistanceSource | null;
  distanceFromLaunchMeters: number | null;
  legSpeedMetersPerSecond: number | null;
  runAverageSpeedMetersPerSecond: number | null;
  latitude: number | null;
  longitude: number | null;
}

export interface TrackingWorksheetRunSummary {
  pigRunId: number;
  runName: string;
  jobNumber: string | null;
  pipelineName: string | null;
  lifecycleState: string;
  launchTimeUtc: Date | null;
  receiveTimeUtc: Date | null;
  currentSpeedMetersPerSecond: number | null;
  verifiedMarkerCount: number;
  markerCount: number;
  deviceCount: number | null;
  passageCount: number | null;
  verifiedPassageCount: number | null;
  nextMarkerName: string | null;
  nextMarkerEtaUtc: Date | null;
  endEtaUtc: Date | null;
  lastUpdatedUtc: Date | null;
}

export interface TrackingWorksheet {
  summary: TrackingWorksheetRunSummary;
  distanceFromLaunchSource: TrackingWorksheetDistanceSource;
  rows: TrackingWorksheetRow[];
  builtAtUtc: Date;
}
